/**
 * <dogscan-accordion> — expand/collapse process steps.
 * data-single="true" closes siblings; data-open-first opens item 1 on load.
 * INSTALL: upload to the theme's assets/.
 */
if (!customElements.get('dogscan-accordion')) {
  class DogscanAccordion extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.dogscan-process__item'));
      if (!this.items.length) return;
      this.single = this.dataset.single === 'true';

      this.onClick = this.onClick.bind(this);
      this.items.forEach((item) => {
        const head = item.querySelector('.dogscan-process__head');
        if (head) head.addEventListener('click', this.onClick);
      });

      if (this.dataset.openFirst === 'true') this.open(this.items[0]);
    }

    disconnectedCallback() {
      this.items.forEach((item) => {
        const head = item.querySelector('.dogscan-process__head');
        if (head) head.removeEventListener('click', this.onClick);
      });
    }

    onClick(event) {
      const item = event.currentTarget.closest('.dogscan-process__item');
      if (item.classList.contains('is-open')) this.close(item);
      else this.open(item);
    }

    open(item) {
      if (this.single) this.items.forEach((it) => { if (it !== item) this.close(it); });
      const body = item.querySelector('.dogscan-process__body');
      const head = item.querySelector('.dogscan-process__head');
      item.classList.add('is-open');
      if (head) head.setAttribute('aria-expanded', 'true');
      if (body) body.style.maxHeight = body.scrollHeight + 40 + 'px';
    }

    close(item) {
      const body = item.querySelector('.dogscan-process__body');
      const head = item.querySelector('.dogscan-process__head');
      item.classList.remove('is-open');
      if (head) head.setAttribute('aria-expanded', 'false');
      if (body) body.style.maxHeight = null;
    }
  }
  customElements.define('dogscan-accordion', DogscanAccordion);
}
